import type { SVGProps } from 'react';
import * as React from 'react';

const ActivitiesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="filled/activities">
      <g id="Icon">
        <path
          d="M19.53 6.87996C20.8555 6.87996 21.93 5.80544 21.93 4.47996C21.93 3.15447 20.8555 2.07996 19.53 2.07996C18.2045 2.07996 17.13 3.15447 17.13 4.47996C17.13 5.80544 18.2045 6.87996 19.53 6.87996Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.53 8.38C19.776 8.38 20.0166 8.35723 20.25 8.31367V18.25C20.25 19.3546 19.3546 20.25 18.25 20.25H5.75C4.64543 20.25 3.75 19.3546 3.75 18.25V5.75C3.75 4.64543 4.64543 3.75 5.75 3.75H15.6982C15.6534 3.98647 15.63 4.2305 15.63 4.48C15.63 6.63391 17.3761 8.38 19.53 8.38ZM17.0408 10.713C17.2966 10.3872 17.2397 9.91574 16.9139 9.66001C16.588 9.40428 16.1166 9.46111 15.8609 9.78696L13.5831 12.6892L10.7852 10.46C10.6274 10.3342 10.4255 10.2774 10.2253 10.3023C10.025 10.3272 9.84325 10.4318 9.72103 10.5923L6.71436 14.5425C6.46349 14.8721 6.52731 15.3427 6.85691 15.5936C7.18651 15.8444 7.65708 15.7806 7.90795 15.451L10.4502 12.111L13.2393 14.3332C13.3956 14.4577 13.5952 14.5147 13.7937 14.4915C13.9922 14.4683 14.1733 14.3668 14.2966 14.2096L17.0408 10.713Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default ActivitiesIcon;
